import React, { useContext, useMemo } from 'react';
import { SessionContextType, SessionProviderProps } from './types';

const SessionContext = React.createContext<SessionContextType | undefined>(
  undefined,
);

export const SessionProvider: React.FC<SessionProviderProps> = ({
  children,
  sessionId,
}) => (
  <SessionContext.Provider value={useMemo(() => ({ sessionId }), [sessionId])}>
    {children}
  </SessionContext.Provider>
);

export function useSession() {
  const context = useContext(SessionContext);

  if (context === undefined) {
    throw new Error('useSession must be used within SessionProvider');
  }

  return context;
}
